import { Card, CardHeader, CardFooter, Button, CardBody, Heading, Text } from "grommet";
import { Gift } from "grommet-icons"
import React from "react";
import { IBoughtOne } from "./i-bought-one";
export type RegistryCardProps = {
    header: string,
    description: string,
    purchased: string,
    total: string,
    item_type: string,
    refreshItems: () => void,
}

export const RegistryCard: React.FC<RegistryCardProps> = (props: RegistryCardProps) => {
    const { header, description, purchased, total, item_type, refreshItems } = props;
    const [show, setShow] = React.useState(false);

    return (
        <Card height={{ min: "275px", max: "275px" }} width={{ min: "275px", max: "275px" }} background="green_constant" border={{ size: "medium", color: "light_green_constant" }} margin="small" style={{ boxShadow: "none" }} pad="small">
            <CardHeader pad="small" alignSelf="center" >
                <Heading className="card-header" weight="normal" size="38px" color="light_green_constant" textAlign="center" >
                    {header}
                </Heading>
            </CardHeader>
            <CardBody pad="small" >
                <Text alignSelf="center" textAlign="center">{description}</Text>
            </CardBody>
            <CardBody pad="small">
                <Text alignSelf="center" textAlign="center" weight="bold" >{purchased}/{total} purchased</Text>
            </CardBody>

            <CardFooter pad="small" alignSelf="center" >
                <Button
                    icon={<Gift />}
                    hoverIndicator
                    label="I bought one!"
                    alignSelf="center"
                    style={{ border: "solid" }}
                    onClick={() => { setShow(true) }}
                />
            </CardFooter>
            {show && (
                <IBoughtOne
                    item_type={item_type}
                    setShow={setShow}
                    addPurchase={refreshItems} />
            )}
        </Card>
    );
}
